// extracted by mini-css-extract-plugin
export default {"container":"TopBar_container__v+eiq","nav-item":"TopBar_nav-item__olzol","avatar":"TopBar_avatar__p2ZdI","balance":"TopBar_balance__LkukP"};